export default __webpack_public_path__ + "static/media/decada-0070-0010-min.7a9c56c1.jpg";